import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

export default class extends Controller {
  static targets = ['canvas', 'colorSource']

  connect() {
    this.canvasTarget.parentNode.style.height = this.canvasTarget.getAttribute('data-height')
    let chartType = this.canvasTarget.getAttribute('data-chart-type') || 'bar'
    let color = this.hasColorSourceTarget ? window.getComputedStyle(this.colorSourceTarget).backgroundColor : '#000'
    let ctx = this.canvasTarget.getContext('2d')
    const isDarkMode = document.documentElement.getAttribute('data-bs-theme') === 'dark'
    const labelColor = isDarkMode ? '#ffffff' : undefined
    const gridColor = isDarkMode ? '#505050' : undefined
    let chart = new Chart(ctx, {
      type: chartType,
      data: {
          labels: JSON.parse(this.canvasTarget.getAttribute('data-labels')),
          datasets: [
            {
              label: this.canvasTarget.getAttribute('data-title'),
              backgroundColor: color,
              borderColor: color,
              pointBackgroundColor: labelColor,
              pointBorderColor: labelColor,
              data: JSON.parse(this.canvasTarget.getAttribute('data-data')),
              showLine: false
            }
          ],
      },
      options: {
        // Don't let the graph height shrink to a tiny size if the viewport width is small
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: {
            ticks: {
              color: labelColor
            },
            grid: {
              color: gridColor
            }
          },
          y: {
            display: true,
            ticks: {
              color: labelColor,
              // Don't show negative scale on y-axis when all counts are zero
              beginAtZero: true,
              // Don't show non-integer tick values on the y-axis
              callback: function(value) { if (value % 1 === 0) { return value } }
            },
            grid: {
              color: gridColor
            },
            min: 0
          }
        }
      }
    });
  }
}
